import type { LocationQuery } from "vue-router";

const SKIP_APP_DOWNLOAD_KEY = "controla_skip_app_download";

// Keep the choice through full-page SSO redirects and email verification.
export function captureSkipAppDownload(query: LocationQuery): void {
  if (query.skip_app_download === "true") {
    sessionStorage.setItem(SKIP_APP_DOWNLOAD_KEY, "true");
  } else if (query.skip_app_download === "false" || query.logout === "true") {
    clearSkipAppDownload();
  }
}

export function shouldSkipAppDownload(): boolean {
  return sessionStorage.getItem(SKIP_APP_DOWNLOAD_KEY) === "true";
}

export function clearSkipAppDownload(): void {
  sessionStorage.removeItem(SKIP_APP_DOWNLOAD_KEY);
}
